// extracted by mini-css-extract-plugin
export var displayNone = "_rz-6";
export var imgContainer = "_rz-2";
export var overflowHidden = "_rz-3";
export var productInfoCardButtonContainer = "_rz-5";
export var productTitleText = "_rz-4";
export var rightArrow = "_rz-1";
export var rightArrowContainer = "_rz-0";